import { useGetMerchantOrderQuery, usePageSettings } from '@p2p/services';
import { useParams } from 'react-router-dom';

export class ErrorPaymentData extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PaymentDataError';
  }
}

export const usePaymentData = () => {
  const { id = '' } = useParams();
  const { data: order } = useGetMerchantOrderQuery(id);
  const { data: pageSettings } = usePageSettings({ order });

  if (!order || !pageSettings) {
    throw new ErrorPaymentData('Payment data is not loaded');
  }

  return { order, pageSettings };
};
